import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/assets";
import { Instagram } from "lucide-react";

const logo = ASSETS.logo;

export const Footer = () => {
  return (
    <footer id="contato" className="relative bg-footer text-footer-foreground py-10 md:py-12">
      {/* Brand gradient top accent */}
      <div aria-hidden className="absolute inset-x-0 top-0 h-1 bg-gradient-brand" />
      <div className="container">
        {/* Brand + contato */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 pb-8 border-b border-footer-foreground/15">
          <div>
            <img
              src={logo}
              alt="Biz Certificadora Digital"
              className="h-12 md:h-14 w-auto max-w-[220px] object-contain mb-3"
              width="220"
              height="56"
            />
            <p className="text-xs md:text-sm text-footer-foreground/80 leading-relaxed">
              Biz Certificadora Digital Serviços em Tecnologia Ltda
              <br />
              CNPJ: 49.132.357/0001-12
              <br />
              R. da Glória, 108 — Liberdade, São Paulo/SP
            </p>
          </div>
          <div className="md:text-right">
            <p className="text-xs text-footer-foreground/80 mb-1">Atendimento</p>
            <p className="text-lg font-semibold">
              <a
                href="tel:+551152397247"
                className="hover:text-footer-foreground transition-colors"
              >
                (11) 5239-7247
              </a>
            </p>
            <p className="text-sm mt-1">
              <a
                href="mailto:suporte@certificadoradigital.com"
                className="hover:text-footer-foreground transition-colors"
              >
                suporte@certificadoradigital.com
              </a>
            </p>
            <p className="text-xs text-footer-foreground/60 mt-2">Segunda a sexta · 9h às 18h</p>
          </div>
        </div>

        {/* Linhas essenciais + copyright + social */}
        <div className="pt-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-footer-foreground/70">
            <Link
              to="/privacidade"
              className="hover:text-footer-foreground transition-colors"
            >
              Privacidade
            </Link>
            <span className="text-footer-foreground/30">·</span>
            <Link
              to="/termos-de-servico"
              className="hover:text-footer-foreground transition-colors"
            >
              Termos
            </Link>
            <span className="text-footer-foreground/30">·</span>
            <Link
              to="/excluir-meus-dados"
              className="hover:text-footer-foreground transition-colors"
            >
              Excluir meus dados
            </Link>
            <span className="text-footer-foreground/30">·</span>
            <Link
              to="/contato-e-suporte"
              className="hover:text-footer-foreground transition-colors"
            >
              Contato
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/certificadoradigital"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-footer-foreground/60 hover:text-footer-foreground transition-colors"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <span className="text-xs text-footer-foreground/50">
              © {new Date().getFullYear()} Biz Certificadora Digital
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
